import axios from "axios";

import * as types from "./actionTypes";
import { navigateToRatings } from "./navigationActions";
import { beginAjaxCall, ajaxCallError } from "./ajaxStatusActions";
import ResponseStatus from "../utils/responseStatus";

export const updateRating = data => dispatch => {
  dispatch(beginAjaxCall());

  axios
    .put(`rating`, data)
    .then(response => {
      if (ResponseStatus.IsOK(response.status)) {
        dispatch({
          type: types.RATING_UPDATE,
          data: response.data
        });

        dispatch(navigateToRatings());
      } else {
        dispatch(ajaxCallError());
      }
    })
    .catch(error => {
      dispatch(ajaxCallError());
      throw error;
    });
};
